import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import PasswordGate from './components/PasswordGate';
import Welcome from './pages/Welcome';
import Page1Top20Anunciantes from './pages/Page1Top20Anunciantes';
import Top25Anunciantes2024 from './pages/Top25Anunciantes2024';
import Top25Anunciantes2023 from './pages/Top25Anunciantes2023';
import Top25Anunciantes2022 from './pages/Top25Anunciantes2022';
import Top25Anunciantes2021 from './pages/Top25Anunciantes2021';
import Top25Anunciantes2020 from './pages/Top25Anunciantes2020';
import PageOrigenInversion from './pages/PageOrigenInversion';
import PageOrigenInversion2 from './pages/PageOrigenInversion2';
import PageIndustriaAnio from './pages/PageIndustriaAnio';
import PageIndustriaDomestica from './pages/PageIndustriaDomestica';
import PageIndustriaTransnacional from './pages/PageIndustriaTransnacional';
import PageIndustriaGobierno from './pages/PageIndustriaGobierno';
import PageTop10Origen from './pages/PageTop10Origen';
import PageTop10Gobierno from './pages/PageTop10Gobierno';
import PageTop25Categorias from './pages/PageTop25Categorias';
import Top25Categorias2024 from './pages/Top25Categorias2024';
import Top25Categorias2023 from './pages/Top25Categorias2023';
import Top25Categorias2022 from './pages/Top25Categorias2022';
import Top25Categorias2021 from './pages/Top25Categorias2021';
import Top25Categorias2020 from './pages/Top25Categorias2020';
import PageRankingHistoricoCat from './pages/PageRankingHistoricoCat';
import PageMixMedioInversion from './pages/PageMixMedioInversion';
import PageMixMedioInversion2 from './pages/PageMixMedioInversion2';
import PageMedioTV from './pages/PageMedioTV';
import PageMedioRadio from './pages/PageMedioRadio';
import PageMedioPrensa from './pages/PageMedioPrensa';
import PageMedioOOH from './pages/PageMedioOOH';
import PageTop10TV from './pages/PageTop10TV';
import PageRankingHistorico from './pages/PageRankingHistorico';
import PageRankingInversion from './pages/PageRankingInversion';
import PageTop25Canal from './pages/PageTop25Canal';
import PageTop10Radio from './pages/PageTop10Radio';
import PageTop25Radio from './pages/PageTop25Radio';
import PageTop10Prensa from './pages/PageTop10Prensa';
import PageTop25Prensa from './pages/PageTop25Prensa';
import PageHighlights from './pages/PageHighlights';
import PageTop20Spots from './pages/PageTop20Spots';
import PageRaceTV from './pages/PageRaceTV';
import PageRaceAnunciantes from './pages/PageRaceAnunciantes';
import PageGracias from './pages/PageGracias';

function App() {
  return (
    <PasswordGate>
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/top25-anunciantes" element={<Page1Top20Anunciantes />} />
          <Route path="/top25-anunciantes-2024" element={<Top25Anunciantes2024 />} />
          <Route path="/top25-anunciantes-2023" element={<Top25Anunciantes2023 />} />
          <Route path="/top25-anunciantes-2022" element={<Top25Anunciantes2022 />} />
          <Route path="/top25-anunciantes-2021" element={<Top25Anunciantes2021 />} />
          <Route path="/top25-anunciantes-2020" element={<Top25Anunciantes2020 />} />
          <Route path="/origen-inversion" element={<PageOrigenInversion />} />
          <Route path="/origen-inversion-2" element={<PageOrigenInversion2 />} />
          <Route path="/industria-anio" element={<PageIndustriaAnio />} />
          <Route path="/industria-anio-domestica" element={<PageIndustriaDomestica />} />
          <Route path="/industria-anio-transnacional" element={<PageIndustriaTransnacional />} />
          <Route path="/industria-anio-gobierno" element={<PageIndustriaGobierno />} />
          <Route path="/top-10-origen" element={<PageTop10Origen />} />
          <Route path="/top-10-gobierno" element={<PageTop10Gobierno />} />
          <Route path="/mixmedio-inversion" element={<PageMixMedioInversion />} />
          <Route path="/mixmedio-inversion-2" element={<PageMixMedioInversion2 />} />
          <Route path="/medio-tv" element={<PageMedioTV />} />
          <Route path="/medio-radio" element={<PageMedioRadio />} />
          <Route path="/medio-prensa" element={<PageMedioPrensa />} />
          <Route path="/medio-ooh" element={<PageMedioOOH />} />
          <Route path="/top-10-tv" element={<PageTop10TV />} />
          <Route path="/top25-categorias" element={<PageTop25Categorias />} />
          <Route path="/top25-categorias-2024" element={<Top25Categorias2024 />} />
          <Route path="/top25-categorias-2023" element={<Top25Categorias2023 />} />
          <Route path="/top25-categorias-2022" element={<Top25Categorias2022 />} />
          <Route path="/top25-categorias-2021" element={<Top25Categorias2021 />} />
          <Route path="/top25-categorias-2020" element={<Top25Categorias2020 />} />
          <Route path="/ranking-historico-categorias" element={<PageRankingHistoricoCat />} />
          <Route path="/ranking-historico" element={<PageRankingHistorico />} />
          <Route path="/ranking-inversion" element={<PageRankingInversion />} />
          <Route path="/top25-canal/:slug" element={<PageTop25Canal />} />
          <Route path="/top-10-radio" element={<PageTop10Radio />} />
          <Route path="/top25-radio/:slug" element={<PageTop25Radio />} />
          <Route path="/top-10-prensa" element={<PageTop10Prensa />} />
          <Route path="/top25-prensa/:slug" element={<PageTop25Prensa />} />
          <Route path="/highlights" element={<PageHighlights />} />
          <Route path="/top20-spots" element={<PageTop20Spots />} />
          <Route path="/race-tv" element={<PageRaceTV />} />
          <Route path="/race-anunciantes" element={<PageRaceAnunciantes />} />
          <Route path="/gracias" element={<PageGracias />} />
        </Routes>
      </div>
    </BrowserRouter>
    </PasswordGate>
  );
}

export default App;
